// extracted by mini-css-extract-plugin
export var notificationHost = "_jc-0";